import React, { useRef, useMemo } from 'react';
import Button from 'react-bootstrap/Button';
import DismissableModal from 'components/DismissableModal';
import { MdDeleteForever } from 'react-icons/md';
import ToggleIconLinkButton from 'components/ToggleIconLinkButton';
import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import { getErrorMessage } from 'services/UtilityService';
import { showNotification } from 'services/NotificationService';

// groupName, dsgId, onSuccessDelete, codexId
const DynamicSwitchGroupDeleteModal = ({ dsgId, groupName, onSuccessDelete, codexId }) => {
  const modalRef = useRef(null);
  const modalRefId = useMemo(() => `DynamicSwitchGroupDeleteModal_${dsgId}`, [dsgId]);

  const onSuccess = () => {
    onSuccessDelete();
    // dispatch success notification
    showNotification({
      title: `Group Deleted!`,
      message: `Group deleted successfully`,
      position: "tr",
      type: "success"
    });
  }

  const onError = (r) => {
    // dispatch failure notification
    showNotification({
      title: "Something went wrong!",
      message:
        getErrorMessage(r.data) ||
        getErrorMessage("UNABLE_TO_DELETE_DYNAMIC_SWITCH_GROUP"),
      position: "tr",
      type: "error"
    });
  }

  const handleDeleteItem = () => {
    sendAuthenticatedAsyncRequest(
      `/cat/codex-version/${codexId}/dynamic-switch-groups/${dsgId}`,
      "DELETE",
      null, onSuccess, onError);
    closeModal();
  }

  const openModal = () => {
    if (modalRef.current) {
      modalRef.current.handleShow();
    }
  }
  
  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.handleClose();
    }
  }

  const modalOpener = <ToggleIconLinkButton
    key={`delete-${dsgId}`}
    shouldDisplayFirstTag={true}
    toggleButton={openModal}
    FirstIcon={MdDeleteForever}
    firstTag={"Delete"}
    linkClassName={'delete-link'}
    SecondIcon={null}
    secondTag={null}
  />;
  const customFooterContent = <div>
    <Button key={`dynamic-switch-group-delete-modal-cancel-${dsgId}`} id='dynamic-switch-group-delete-modal-cancel-button' variant="outline-dark" onClick={closeModal}>Cancel</Button>
    <Button
      key={`dynamic-switch-group-delete-modal-${dsgId}`}
      id='dynamic-switch-group-modal-delete-button'
      className="left-spacer"
      variant="danger"
      onClick={handleDeleteItem}>
      Delete
    </Button>
  </div>;
  const title = "Delete Group ?";
  return (
    <DismissableModal
      ref={modalRef}
      key={dsgId}
      customFooterContent={customFooterContent}
      openModalButton={modalOpener}
      title={title}
      id='dynamic-switch-group-delete-modal-dismissable-modal'
    >
      <p >
        Are you sure you want to delete the group <strong >{groupName}</strong>?
      </p>

    </DismissableModal>
  );
}

export default DynamicSwitchGroupDeleteModal;